/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import "@polymer/iron-input/iron-input.js";
import template from "./ns-number-increment.html";

/**
 * The ns-number-increment should be used for
 *
 * <h1>Number Increment</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-number-increment></ns-number-increment>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsNumberIncrement extends PolymerElement {
  static get is() {
    return "ns-number-increment";
  }

  static get properties() {
    return {
      value: {
        type: Number,
        notify: true,
        observer: "rangeValidator"
      },
      numberIncrementPublishEventName: {
        type: String
      },
      maxNumber: {
        type: Number,
        value: 99
      },
      minNumber: {
        type: Number,
        value: 1
      }
    };
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  constructor() {
    super();
  }

  ready() {
    super.ready();
    if (!this.value) {
      this.value = this.minNumber;
    }
  }

  decreaseQty() {
    if (this.value > this.minNumber) {
      this.value--;
    }
  }

  increaseQty() {
    if (this.value <= this.maxNumber) {
      this.value++;
    }
  }

  rangeValidator(newValue, oldValue) {
    newValue = parseInt(newValue);
    if (isNaN(newValue) || !newValue) {
      // Ensuring non-number handling (CX15-4697)
      newValue = this.lastGoodValue || 1;
    } else {
      if (newValue > this.maxNumber) {
        this.value = this.maxNumber;
      } else if (newValue < this.minNumber) {
        this.value = this.minNumber;
      } else {
        this.value = newValue;
      }
      this.lastGoodValue = this.value;
    }
  }
}
customElements.define(NsNumberIncrement.is, NsNumberIncrement);
